import script from "./ReviewTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewTable.vue?vue&type=script&setup=true&lang=js"

import "./ReviewTable.vue?vue&type=style&index=0&id=26664b02&scoped=true&lang=css"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26664b02"]])

export default __exports__